import { useApiClient } from 'bff/ApiClientProvider';
import { queryOptions } from '@tanstack/react-query';

export const getAssetManagers = () => {
  const { reportingApi } = useApiClient();

  return queryOptions({
    queryKey: ['assetManagers'],
    queryFn: async () => reportingApi.reportingGetAssetManagers(),
    select: (response) => response.data?.assetManagers
  });
};
